import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { AccountDetailSaveModel } from '../../account-details/models/account-detail-save.model';

export const addAccount = createAction('[Add Account] Add Account');

export const createAccount = createAction(
   '[Create Account] Create Account',
   props<{ account: AccountDetailSaveModel }>()
);

export const createAccountSuccess = createAction(
   '[API] Create Account Success',
   props<{ accountId: number; accountName: string | null }>()
);

export const createAccountFailure = createAction('[API] Create Account Failure', props<SingleGraphError>());

export const removeExtensionInUseConfirmation = createAction(
   '[Create Account] Remove Extension In Use Confirmation',
   props<{ extensionNumber: string; phoneNumber: string }>()
);

export const removeExtensionInUseConfirmed = createAction('[Create Account] Remove Extension In Use Confirmed');

export const removeExtensionInUseCancelled = createAction('[Create Account] Remove Extension In Use Cancelled');
